<template>
    <HeaderPage/>
    <HeroSection/>
    <AboutSection/>
    <ServicesSection/>
    <ProjectSection/>
    <ContactSection/>
    <FooterPage/>
</template>

<script>
import HeaderPage from "@/components/HeaderPage.vue";
import FooterPage from "@/components/FooterPage.vue";
import HeroSection from "@/components/HeroSection.vue";
import AboutSection from "@/components/AboutSection.vue";
import ProjectSection from "@/components/ProjectSection.vue";
import ContactSection from "@/components/ContactSection.vue";
import ServicesSection from "@/components/ServicesSection.vue";

export default {
    name: 'App',
    components: {
        HeaderPage,
        FooterPage,
        HeroSection,
        AboutSection,
        ContactSection,
        ProjectSection,
        ServicesSection,
    }
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>
